/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_BranchesInputs */

const vi_shop_home_branches = /** @type {(inputs: Shop_Home_BranchesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chi nhánh (tối đa ${i?.max}, kéo để đổi thứ tự)`)
};

/**

* @param {Shop_Home_BranchesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_branches = /** @type {((inputs: Shop_Home_BranchesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_BranchesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_branches(inputs)
});